import ReactGA from "react-ga4";

// Inicializa o Google Analytics com seu ID de medição
export const initGA = (measurementId: string) => {
  if (typeof window !== "undefined") {
    ReactGA.initialize(measurementId);
  }
};

// Registra uma visualização de página
export const logPageView = (path?: string) => {
  const currentPath = path || window.location.pathname + window.location.search;
  ReactGA.send({ hitType: "pageview", page: currentPath });
};

// Registra um evento
export const logEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Registra informações do usuário
export const setUser = (userId: string) => {
  ReactGA.set({ userId });
};
